import { useNavigate } from "react-router-dom";

import 'styles/ActivityList.css';

export function ActivityCard({activity, hideCreator}) {

  const navigate = useNavigate();

  return (
    <div className="activity-card" onClick={()=>{navigate(`/t/${activity?.shortId}`)}}>
      <div>{activity?.title}</div>
      { hideCreator || <div><i>with</i> {activity?.creator.name}</div> }
      <div><i>at</i> {activity?.location.name}</div>
      {
        activity?.userRole==='requester'   ? <div className="requested-status"/> :
        activity?.userRole==='participant' ? <div className="approved-status"/> :
        null
      }
    </div>
  )
}

export function ActivityList({activities, loading, hideCreator, scrollbar, popping}) {
  return (
    <div className={"activity-list" + (scrollbar==='mandatory' ? ' scrollbar' : '') + (popping ? ' popping' : '')}>
      {
        loading ?
        <div>Loading...</div> :

        activities===undefined || activities===null ?
        <div>Some error occurred while trying to get this set of activities.</div> :

        activities.length===0 ?
        <div style={{color: 'gray'}}>(No activities)</div> :

        activities.map(activity => <ActivityCard key={activity.id} activity={activity} hideCreator={hideCreator}/>)
      }
    </div>
  )
}